/**
 * Tema: claro e o padrao; escuro existe pelo atributo `data-tema` na raiz.
 *
 * O mecanismo e este arquivo inteiro. Nenhuma tela do sistema escreve cor
 * propria — tudo sai de token —, entao trocar o atributo troca a aplicacao
 * inteira, e a paridade de funcoes entre os dois temas e estrutural, nao uma
 * lista de telas que alguem precisa lembrar de portar.
 *
 * POR QUE NAO HA BOTAO DE TROCAR TEMA NESTA VERSAO
 * A tabela de equivalencia do manual (p.21) cobre SETE tokens: surface-canvas,
 * surface-card, border-default, text-primary, brand-action e status-operando.
 * Continuam sem par escuro: `surface-sunken`, `border-subtle`, `text-secondary`,
 * `text-muted` e os pares de standby, parada, informacao e nao-alocado.
 * Ligar o escuro hoje entregaria texto secundario cinza-claro sobre fundo
 * escuro — ilegivel. Inventar os valores que faltam e proibido; o certo e
 * perguntar. O botao entra no mesmo dia em que o manual fechar esses tokens.
 */

export type Tema = 'claro' | 'escuro';

const CHAVE = 'ct-frotas:tema';

export function aplicarTema(tema: Tema): void {
  document.documentElement.dataset['tema'] = tema;
}

/**
 * Le a preferencia guardada. Sem preferencia, claro — que e o oficial.
 *
 * O `try/catch` nao e paranoia: em navegador com armazenamento de site
 * bloqueado, `localStorage` nao devolve `null`, ele LEVANTA. Sem o catch, a
 * aplicacao inteira deixa de montar por causa de uma preferencia de cor.
 */
export function lerTemaSalvo(): Tema {
  let guardado: string | null = null;
  try {
    guardado = window.localStorage.getItem(CHAVE);
  } catch {
    // Armazenamento bloqueado. O padrao resolve.
  }
  return guardado === 'escuro' ? 'escuro' : 'claro';
}

/** Guarda a escolha. Falhar aqui nao pode derrubar a troca de tema em si. */
export function salvarTema(tema: Tema): void {
  try {
    window.localStorage.setItem(CHAVE, tema);
  } catch {
    // Armazenamento bloqueado: o tema vale para esta sessao e pronto.
  }
}

/** Le a preferencia guardada e aplica. Chamado uma vez, antes de montar. */
export function aplicarTemaSalvo(): Tema {
  const tema = lerTemaSalvo();
  aplicarTema(tema);
  return tema;
}
